//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from "@/api/PMS/blackListManage/index";
export default {
  data: function data() {
    return {
      rules: {
        name: [{
          required: true,
          message: "请输入用户姓名",
          trigger: "change"
        }],
        // activityManageName: [
        //   {
        //     required: true,
        //     message: "请选择项目",
        //     trigger: "change"
        //   }
        // ],
        tel: [{
          required: true,
          message: "请输入联系方式",
          trigger: "change"
        }],
        rangeDate: [{
          required: true,
          message: "请选择拉黑时间",
          trigger: "change"
        }]
      },
      dialogFormVisible: false,
      id: -1,
      childData: {
        name: "",
        tel: "",
        rangeDate: [],
        startDate: "",
        endDate: ""
      },
      periodIdList: [],
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      }
    };
  },
  props: ["keyValue", "showDialog", "activityManageId"],
  created: function created() {
    this.init();
  },
  components: {},
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs["dataForm"].resetFields();

        if (this.showDialog) {
          this.init();
        }
      }
    }
  },
  methods: {
    handleRegistrationDate: function handleRegistrationDate(val) {
      if (val && val.length > 0) {
        this.$set(this.childData, "rangeDate", val);
        this.$set(this.childData, "startDate", val[0]);
        this.$set(this.childData, "endDate", val[1]);
      }
    },
    init: function init() {
      this.loadData();
    },
    loadData: function loadData() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs["dataForm"].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;

          if (_this.childData.startDate && _this.childData.endDate) {
            var time = [];
            time = [_this.childData.startDate, _this.childData.endDate];

            _this.$set(_this.childData, "rangeDate", time);
          }
        });
      } else {
        this.childData = {
          name: "",
          tel: "",
          rangeDate: [],
          startDate: "",
          endDate: ""
        };
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs["dataForm"].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit("handCancle", true);

              _this2.Alert({
                alertType: "update"
              });
            });
          } else {
            _this2.$set(_this2.childData, "activityManageId", _this2.activityManageId);

            fetchCreate(_this2.childData).then(function () {
              _this2.keyValue = -1;

              _this2.$emit("handCancle", true);

              _this2.Alert({
                alertType: "add"
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: "valid"
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit("handCancle", false);
    }
  }
};